app.service('basketView',function(pageConfig, cartManager, log, cookie, broker, loading, warrantyEncouragement, confirmCartRecalculateModal, warrantyQuestionnaire){
	var $self;
	var config, basket;

	function setElements() {
		$self = $('#cart');
		config = pageConfig.getData('order');
		basket = pageConfig.getData('basket');
	}
	function handleWarrantyEncouragementClick(){ //on .js-show-basket-warranties
		var $selectedWarrantyButton = $(this);

		warrantyEncouragement.load({
			redirectUrl: '/cart.bhtml'
		}, {
			productId: $selectedWarrantyButton.data('product'),
			packageIdentifier: $selectedWarrantyButton.data('package-identifier'),
			unpaidReservation: $selectedWarrantyButton.data('unpaid-reservation'),
			complaintExchange: $selectedWarrantyButton.data('complaint-exchange'),
			relatedPromotionIdentifier: $selectedWarrantyButton.data('related-promotion-identifier')
		}, function (params) {
			if(params.productId == config.productIdForInstalmentProductWithWarranty && params.warrantyId != config.warrantyIdForInstalmentProductWithWarranty){
				confirmCartRecalculateModal.show(function(){
					cartManager.addWarranty(params);
				});
			}else{
				cartManager.addWarranty(params);
			}
		}, function (params) {
			if(params.productId == config.productIdForInstalmentProductWithWarranty){
				confirmCartRecalculateModal.show(function(){
					cartManager.removeWarranty(params);
				});
			}else{
				cartManager.removeWarranty(params);
			}
		});

	}
	function handleWarrantyClick(){
		//on .js-select-warranty
		var $selectedWarrantyButton = $(this);
		// sprawdzenie czy w ramach danego produktu zmieniane jest PG.
		var $warrantyBox = $selectedWarrantyButton.closest('.cart-warranty-box');
		var $selectedInstalmentWarrantyButton = $warrantyBox.find('.js-select-warranty.selected[data-id="'+config.warrantyIdForInstalmentProductWithWarranty+'"]');
		var isInstalmentProductWarrantyBox = $warrantyBox.data('product') == config.productIdForInstalmentProductWithWarranty;
		var isWarrantyChanged = $selectedInstalmentWarrantyButton.data('id') != $selectedWarrantyButton.data('id');
		var showModalMessage = (isInstalmentProductWarrantyBox && $selectedInstalmentWarrantyButton.length > 0 && isWarrantyChanged);

		var warrantyId = $selectedWarrantyButton.data('id');
		var warrantyPaymentType = $selectedWarrantyButton.data('type');
		var warrantyAddedFrom = config.basketType == 'MIXED' ? 'CART_EDIT_MIXED' : (config.basketType == 'INSTALLMENT' ? 'CART_EDIT_INSTALLMENT' : 'CART_EDIT_COMMON');
		var mainCartItemId = $warrantyBox.data('cart');
		var relatedPromotionIdentifier = $warrantyBox.data('related-promotion-identifier') || undefined;
		var productId = $warrantyBox.data('product');
		var packageIdentifier = $selectedWarrantyButton.data('package-identifier');

		function next(){
			$selectedWarrantyButton.closest('.payment-warranties').find('.selected').removeClass('selected');
			$selectedWarrantyButton.addClass('selected');
			if (warrantyId > 0) {
				cartManager.addWarranty({
					productId: productId,
					warrantyId: warrantyId,
					packageIdentifier: packageIdentifier ? packageIdentifier : false,
					relatedPromotionIdentifier,
					addedFrom: 'CART_EDIT',
					warrantyPaymentType: warrantyPaymentType,
					warrantyAddedFrom,
					callback: function(){
						// funkcja ze starego kodu
						reloadCartView(undefined, function() {
							chceckWarrantiesCount(1, $('#item'+mainCartItemId).find('.filterNumbers').attr('id').substr(8));
						});
					}
				});
			} else {
				cartManager.removeWarranty({
					mainCartItemId: mainCartItemId,
					addedFrom: 'CART_EDIT',
					callback: function(){
						reloadCartView();
					}
				});
			}
		}

		if(showModalMessage) {
			confirmCartRecalculateModal.show(function(){
				next();
			})
		}else{
			next();
		}
	}
	function changeWarrantyType(type, $box){
		const activeType = $box.attr('data-type');
		const mainCartItemId = $box.attr('data-cart');
		const $selected = $box.find('.js-select-warranty.selected');
		const warrantyId = $selected.attr('data-id');
		const $button = $box.find('.js-select-warranty[data-id='+warrantyId+'][data-type='+type+']').not($selected);
		const previousPaymentType = $box.attr('data-type-previous');

		if (warrantyId > 0 || previousPaymentType === type) {
			const data = {
				mainCartItemId,
				warrantyPaymentType: type
			};
			loading.start();
			$.ajax({
				url: '/change-warranty-payment-type.ltr',
				method: 'post',
				data,
				success: function () {
					reloadCartView();
				},
				error: function () {
					loading.stop();
					fancyOk('Wystąpił błąd. Prosimy odświeżyć stronę i spróbować jeszcze raz.');
				}
			});
		} else if ($button.length) {
			$button.click();
		} else {
			if (type) {
				$box.attr('data-type', type);
			} else {
				$box.attr('data-type', $selected.attr('data-type'));
			}
		}
	}
	function setEvents() {
		$('body').on('click', '.js-calculate-user-new-instalment-option', calculateUserNewInstalment);
		$('body').on('click', '.js-show-warranties', function() {
			log.event({
				"id": "Przedluz gwarancje K1",
				"f03": "Wiecej o ubezpieczeniu",
				"f04": $(this).closest('.cart-warranty-box').find('.js-select-warranty.selected').first().data('type') == 'ONE_TIME' ? 'Płatność jednorazowa' : 'Płatność miesięczna',
				"f05":""
			})
		});
		$self.on('click', '.js-remove-product', function(){
			var productPlu = $(this).data('product-plu');
			warrantyQuestionnaire.clearProductWarrantyQuestion(productPlu);
		});
		$self.on('click','.js-select-warranty', handleWarrantyClick);
		$self.on('click', '.js-show-basket-warranties', handleWarrantyEncouragementClick);
		$self.on('change','.cart-warranty-box .select3-container:not(.is-hidden) .select3-input', function(){
			changeWarrantyType($(this).val(), $(this).closest('.cart-warranty-box'));
		});

	}
	function logVoucherErrorCode(){
		if(config.voucherErrorCode && config.voucherErrorCode!=""){
			var fuid = cookie.split('euroVisit');
			fuid = fuid[fuid.length-5];
			var plus = [];
			$(basket.items).each(function(i,n){
				plus.push(n.plu);
			});
			log.event({
				id: 'msg_discount_code',
				f03: cookie.get('euroCart'),
				f04: config.voucherCode,
				f05: plus.join(";"),
				f06: fuid,
				f07: config.voucherErrorCode,
				f08: config.summaryPrice
			});
		}
	}

	function setDefaultWarrantyPayment() {
		const $box = $('.cart-warranty-box');
		$box.each(function () {
			const $select = $(this).find('.select3-container:not(.is-hidden) .select3-input');
			if ($select.length) {
				const value = $select.val();
				if (value) {
					if (value !== $(this).attr('data-type')) {
						changeWarrantyType(value, $(this));
					}
				} else {
					const $selected = $(this).find('.js-select-warranty.selected');
					changeWarrantyType($selected.attr('data-type'), $(this));
				}
			}
		});
	}


	function calculateUserNewInstalment() {
		$('#F_ACTION').val('UPDATE_USER_INSTALMENT_OPTION');
		loading.start();
		$('#cartForm')[0].submit();
	}
	function init(){
		setElements();
		setDefaultWarrantyPayment();
		setEvents();
		logVoucherErrorCode();
		broker.on('REFRESH_BASKET_VIEW',function(){
			loading.reload();
		});
	}
	return {
		init:init
	};
});
